import React, { createContext, useEffect, useState, useContext, useMemo } from 'react'
import firebase from 'src/firebase/firebase'
import authenticateUser from 'src/hooks/useAuthentication'
import { getUserData } from 'src/services/auth.services'
import { AlertContext } from '../alert/alertContext'
import { UserDataTypes } from '../../types/pages.types'
import { getDefaultLang } from 'src/utils/defaultLang'

export interface AuthContextProps {
  user: Record<string, any>
  firebase: any
  userData: UserDataTypes
  setUserData: any
  initLoading: boolean
  language: 'es' | 'en' | 'pt'
  setLanguage: React.Dispatch<React.SetStateAction<'es' | 'en' | 'pt'>>
  logout: () => Promise<void>
}

export const AuthContext = createContext({} as AuthContextProps)

export const AuthProvider = ({ children }: any) => {
  const { showSnackbar } = useContext(AlertContext)
  const [language, setLanguage] = useState(getDefaultLang())


  const [userData, setUserData] = useState<any | null>(null)
  const user = authenticateUser()
  const [initLoading, setInitLoading] = useState(true)

  const logout = async (): Promise<void> => {
    setUserData(null)

    await firebase.logout()
  }

  useEffect(() => {
    if (user.user) {
      // DIAGNÓSTICO TEMPORAL: cuántas veces se recarga userData (cada refresco de
      // token de Firebase). Si sube mucho, era lo que disparaba los re-fetch.
      console.count('[Auth] getUserData')
      getUserData(user.user.uid)
        .then((result) => setUserData(result))
        .then(() => setInitLoading(false))
        .catch((error) => {
          if (error instanceof Error) showSnackbar('error', error.message)
          firebase.logout()
        })
    } else if (user && !user.user && user.userDataPresent) setInitLoading(false)
  }, [user])

  const value = useMemo(
    () => ({ user, userData, setUserData, firebase, initLoading, logout, language, setLanguage }),
    // logout/firebase/setters son estables; memoizar evita que cada render del
    // provider cascada un re-render a todos los consumidores (lo que Safari amplifica).
    [user, userData, initLoading, language]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export default AuthProvider
